/**
 * Browsing context name for Case Management Portal tabs opened from Healthcare Portal.
 * `window.open(url, CASE_MGMT_PORTAL_WINDOW_NAME)` reuses the same tab when it is still open.
 */
export const CASE_MGMT_PORTAL_WINDOW_NAME = 'hsus-case-management-portal';
